import React, { FC } from 'react';
import { SrWidget } from './SrWidget';

export interface SrWidgetSeasonLiveTableProps extends React.HTMLAttributes<HTMLDivElement> {
    matchId: string;
}

export const SrWidgetSeasonLiveTable: FC<SrWidgetSeasonLiveTableProps> = ({ matchId, ...props }) => {
    const widgetProps = { matchId: matchId, disableWidgetHeader: true, disableMatchHeader: true };
    return <SrWidget widgetName="season.liveTable" widgetProps={widgetProps} {...props} />;
};
